export default "__VITE_ASSET__B1Wln0wM__"